/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { LpMetaProps } from "../../../../../types/LpMetaProps";
import { gaSet } from "../../../../../services/googleAnalyticsService";

const LpTrafficAccidentMeta = ({ keyword }: LpMetaProps) => {
  const title = keyword + " | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content="Professionelle Hilfe bei Verkehrsunfällen: Wir setzen Ihre Rechte schnell, sicher und kompromisslos durch!" />
      <meta
        name="keywords"
        content="Verkehrunfall, Verkehrsrecht, Legalbird, Recht, Unfall, "
      />
      <meta name="robots" content="noindex,nofollow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta property="og:description" content="Professionelle Hilfe bei Verkehrsunfällen: Wir setzen Ihre Rechte schnell, sicher und kompromisslos durch!" />
    </Helmet>
  );
};

export default LpTrafficAccidentMeta;
